import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormArray, UntypedFormControl} from '@angular/forms';
import {slugify} from 'shared/_functions/slugify';
import {ControlTemplate} from '../_interface/control-template.enum';
import {isControlRequired} from '../functions/check-if-control-required.fn';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
	selector: 'form-radio-list',
	templateUrl: './radio-list.component.html',
	styleUrls: ['../radio/radio.component.scss'],
})
export class RadioListComponent implements OnInit {

	@Input() options: string[] = [];
	@Input() label: string;
	@Input() control: UntypedFormControl;
	@Input() translationPrefix: string = null;
	@Input() template: ControlTemplate = ControlTemplate.inline;
	@Input() variant: ControlTemplate = ControlTemplate.horizontal;
	@Input() warningOption: string;

	@Input() set setWarnings(warnings: Record<string, any>) {
		if (!warnings) return;
		this.warnings = warnings;
		this.warningsArray = Object.entries(warnings || {})
			.filter(([_, value]) => !!value)
			.map(([key]) => key);
	}

	ControlTemplate = ControlTemplate;
	isControlRequired: boolean;
	warnings: Record<string, any>;
	warningsArray: string[];

	formArray: UntypedFormArray;
	random = Math.random().toPrecision(3);
	name: string;
	idArr: string[] = [];

	constructor() {}

	private setFormArray(value: string = '') {
		this.formArray = new UntypedFormArray(this.options.map((_) => {
			return new UntypedFormControl(value);
		}));
		this.formArray.valueChanges.pipe(
			untilDestroyed(this)
		).subscribe(res => {
			this.control.patchValue(this.options.map((item, index) => res[index] ? item : null));
			this.control.markAsTouched();
			this.control.markAsDirty();
		});
	}

	getName() {
		if (!this.label) {
			this.name = `name-${this.random}`;
			return;
		}
		this.name = `${slugify(this.label)}-${this.random}`;
	}

	getId() {
		if (!this.options) return;
		this.options.forEach((option) => this.idArr.push(`${option}-${this.random}`));
	}

	setValue(i: number) {
		this.control.patchValue(this.options[i]);
		this.control.markAsDirty();
	}

	ngOnInit(): void {
		this.setFormArray(this.control.value || '');
		this.isControlRequired = isControlRequired(this.control);
		this.getName();
		this.getId();
	}

}
